const ChevronIcon = () => (
	<svg
		width="14"
		height="7"
		viewBox="0 0 14 7"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0.578598 0.789296L7 6.2107L13.4214 0.789296"
			stroke="currentColor"
		/>
	</svg>
);

export default ChevronIcon;
